(() => {
  const patch = () => {
    const BhindUpsell = customElements.get('bhind-upsell');
    if (!BhindUpsell || BhindUpsell.prototype.__bhindCompatibilityPatchedV2) return false;

    BhindUpsell.prototype.classify = function(item) {
      const title = String(item.product_title || '').toLowerCase();
      const handle = String(item.handle || '').toLowerCase();
      const variant = String(item.variant_title || '').toUpperCase();
      let family = null;

      if (handle.includes('low-profile-small-bin-divider') || handle.includes('low-profile-large-bin-divider') || handle.includes('low-profile-bin-divider-8431-8436') || title.includes('8431') || title.includes('8436') || title.includes('low profile small bin') || title.includes('low profile large bin')) {
        family = 'compact';
      } else if (handle.includes('milwaukee-packout-bin-divider-fits-48-22-8430-48-22-8435') || handle.includes('packout-large-bin-divider-48-22-8430-48-22-8435') || handle.includes('center-bin-divider') || handle.includes('compatible-bin-divider-kit-for-8430-8435') || title.includes('8430') || title.includes('8435')) {
        family = 'large';
      }
      if (!family) return null;

      if (handle.includes('center-bin-divider') || title.includes('center bin')) return { family: 'large', type: 'CB', units: item.quantity * (variant.includes('DUO') ? 2 : 1) };
      if (handle.includes('low-profile-small-bin-divider')) return { family: 'compact', type: 'SB', units: item.quantity };
      if (handle.includes('low-profile-large-bin-divider')) return { family: 'compact', type: 'LB', units: item.quantity };

      const model = variant.split('/').pop().trim();
      if (model.startsWith('SB')) return { family, type: 'SB', units: item.quantity };
      if (model.startsWith('LB')) return { family, type: 'LB', units: item.quantity };
      return null;
    };

    BhindUpsell.prototype.caseModel = function() {
      const explicit = String(this.dataset.case || '');
      if (['8430','8431','8435','8436'].includes(explicit)) return explicit;
      const context = (window.location.pathname + ' ' + document.referrer).toLowerCase();
      if (context.includes('8431')) return '8431';
      if (context.includes('8436')) return '8436';
      if (context.includes('8430')) return '8430';
      if (context.includes('8435')) return '8435';
      if (this.dataset.family === 'compact') return '8431';
      return '';
    };

    BhindUpsell.prototype.familyMarkup = function(family, current) {
      let capacity;
      let label;
      if (family === 'large') {
        capacity = { SB: 8, LB: 2, CB: 2 };
        label = this.text('Large case · 8430 / 8435', 'Grande valise · 8430 / 8435');
      } else if (this.caseModel() === '8436') {
        capacity = { SB: 4, LB: 1 };
        label = this.text('Compact low-profile case · 8436', 'Valise compacte profil bas · 8436');
      } else {
        capacity = { SB: 8, LB: 2 };
        label = this.text('Low-profile case · 8431', 'Valise profil bas · 8431');
      }

      const totalFilled = Object.keys(capacity).reduce((sum, key) => sum + Math.min(current[key] || 0, capacity[key]), 0);
      const totalCapacity = Object.values(capacity).reduce((sum, value) => sum + value, 0);
      return '<section class="bhind-packout-family"><div class="bhind-packout-family__title"><span>' + label + '</span><span>' + totalFilled + ' / ' + totalCapacity + '</span></div><div class="bhind-capacity-grid">' + Object.entries(capacity).map(([type, max]) => this.capacityMarkup(family, type, current[type] || 0, max)).join('') + '</div></section>';
    };

    BhindUpsell.prototype.capacityMarkup = function(family, type, count, max) {
      const filled = Math.min(count, max);
      const missing = Math.max(0, max - count);
      const complete = missing === 0;
      let url;
      if (family === 'compact') url = type === 'LB' ? (this.dataset.compactLbUrl || this.dataset.compactUrl) : (this.dataset.compactSbUrl || this.dataset.compactUrl);
      else if (type === 'CB') url = this.dataset.cbUrl;
      else if (type === 'LB') url = this.dataset.lbUrl || this.dataset.largeUrl;
      else url = this.dataset.sbUrl || this.dataset.largeUrl;

      const slots = Array.from({ length: max }, (_, index) => '<span class="bhind-capacity__slot' + (index < filled ? ' is-filled' : '') + '"></span>').join('');
      const action = complete ? this.text('Complete', 'Complet') : this.text('Choose ' + type, 'Choisir ' + type);
      const detail = complete ? action : this.text(missing + ' missing', 'Il en manque ' + missing);
      return '<div class="bhind-capacity' + (complete ? ' is-complete' : '') + '"><div class="bhind-capacity__top"><span>' + type + '</span><span>' + count + ' / ' + max + '</span></div><div class="bhind-capacity__slots" aria-hidden="true">' + slots + '</div>' + (complete ? '<span>' + detail + '</span>' : '<a href="' + url + '">' + detail + ' · ' + action + '</a>') + '</div>';
    };

    BhindUpsell.prototype.__bhindCompatibilityPatched = true;
    BhindUpsell.prototype.__bhindCompatibilityPatchedV2 = true;
    return true;
  };

  if (!patch()) document.addEventListener('DOMContentLoaded', patch, { once: true });
})();